export default __webpack_public_path__ + "static/media/img7.fb3d5c83.png";